import React, { forwardRef } from "react";
import TransText from "next-translate/TransText";
import useTranslation from "next-translate/useTranslation";
import ReCAPTCHA from "react-google-recaptcha";

const Captcha = forwardRef((_, ref) => {
  const { t } = useTranslation("common");

  return (
    <div className="mb-8">
      <div className="prose mx-0 max-w-none text-base italic">
        <TransText
          text={t("utils.recaptcha", {}, { returnObjects: true })}
          components={{
            pp: (
              <a
                href="https://policies.google.com/privacy"
                target="_blank"
                rel="noreferrer"
              />
            ),
            tos: (
              <a
                href="https://policies.google.com/terms"
                target="_blank"
                rel="noreferrer"
              />
            ),
          }}
        />
      </div>
      <ReCAPTCHA
        ref={ref}
        size="invisible"
        sitekey={process.env.NEXT_PUBLIC_CAPTCHA_KEY}
      />
    </div>
  );
});

Captcha.displayName = "Captcha";
export default Captcha;
